interface BookingWidgetProps {
  className?: string;
  onClose?: () => void;
}

export default function BookingWidget({
  className = ""
}: BookingWidgetProps) {
  return (
    <div className={className}>
      <div className="rounded-lg shadow-md mx-auto max-w-screen-lg w-full">
        <iframe
          src="https://calendar.google.com/calendar/appointments/schedules/AcZssZ3fagNV-1BHab1h-v_sWAlYzwZqchrb4HJUE6sQyFjJTdaCHxsWIgf1dl0cXa4WU6xth5F8RXld?gv=true"
          style={{ border: 0 }}
          width="100%"
          height="700"
          frameBorder="0"
          title="Schedule a consultation with PCM"
          className="min-h-[500px] md:min-h-[650px]"
        />
      </div>
    </div>
  );
}
